export enum KONFIGURACJA {
  WERSJA_PELNA = 'klient.wersja-pelna',
  TEORIA_WLACZONA = "klient.nauczyciel.praca-domowa.teoria.wlaczona",
  ZMIANA_DANYCH_OSOBOWYCH = "klient.zmiana-danych-osobowych",
  NAWIGACJA_MIEDZY_ZADANIAMI = "klient.uczen.praca-domowa.nawigacja-miedzy-zadaniami",
  PASEK_POSTEPU = "klient.uczen.praca-domowa.pasek-postepu",
  NUMERACJA_ZADAN_LITERKI = "klient.uczen.praca-domowa.numeracja-zadan.z-literkami",
  NUMERACJA_ZADAN_ODKRYWANA = "klient.uczen.praca-domowa.numeracja-zadan.odkrywana",
  BRAK_AKTYWNOSCI = "klient.uczen.praca-domowa.brak-aktywnosci",
  UCZEN_PRACA_DOMOWA_ZADANIE_ID = "klient.uczen.praca-domowa.zadanie_id",
  /**
   * Czy nauczyciel moze zadawac nowe prace domowe. Domyslne nie.
   */
  NAUCZYCIEL_ZADAWANIE_PRACY_DOMOWEJ = "klient.nauczyciel.zadawanie-pracy-domowej",
  NAUCZYCIEL_ZADAWANIE_PRACY_DOMOWEJ_SPOSOB = "klient.nauczyciel.zadawanie-pracy-domowej-sposob",
  NAUCZYCIEL_PRACA_DOMOWA_DATY_ODPOWIEDZI = "klient.nauczyciel.praca-domowa.pokaz-daty-odpowiedzi",
  NAUCZYCIEL_ZADAWANIE_PRACY_DOMOWEJ_NA_PODSTAWIE_LISTY_ZADAN = "klient.nauczyciel.zadawanie-pracy-domowej.na-podstawie-listy-zadan",
  UCZEN_POWTORKI = "klient.uczen.powtorki",
  UCZEN_POWTORKI_NA_ZADANIE = "klient.uczen.powtorki.na-zadanie",
  UCZEN_POMOC_WYJASNIENIA = "klient.uczen.praca-domowa.pomoc.wyjasnienia",
  UCZEN_POMOC_WYSZARZANIE = "klient.uczen.praca-domowa.pomoc.wyszarzanie",
  UCZEN_POMOC_WYSZARZANIE_SPOSOB = "klient.uczen.praca-domowa.pomoc.wyszarzanie.sposob",
  UCZEN_POMOC_WYSZARZANIE_MOMENT = "klient.uczen.praca-domowa.pomoc.wyszarzanie.moment",
  UCZEN_SPRAWDZIANY = "klient.uczen.sprawdziany",
  UCZEN_INDYWIDUALNA_NAUKA = "klient.uczen.indywidualna-nauka",
  UCZEN_PROBLEMY_ROZWIAZANIA = "klient.uczen.problemy.rozwiazania",
  UCZEN_ODZNACZENIE_HEADER_WIELKOSC = "klient.uczen.odnaczenie.header.wielkosc",
  UCZEN_ODZNACZENIE_SIDEBAR_WIELKOSC = "klient.uczen.odnaczenie.sidebar.wielkosc",
  UCZEN_ODZNACZENIE_LISTA_ODZNACZEN_WIELKOSC = "klient.uczen.odnaczenie.lista.odznaczen.wielkosc",
  UCZEN_PRACA_DOMOWA_SCROLL_INFO = "klient.uczen.praca-domowa.scroll-info",
  UCZEN_PRACA_DOMOWA_SCROLL_INFO_BLOKUJ_ODPOWIADANIE = "klient.uczen.praca-domowa.scroll-info.blokuj-odpowiadanie",

  /**
   * Czy nauczyciel moze tworzyc kartkowki. Domyslnie nie.
   */
  NAUCZYCIEL_KARTKOWKI = "klient.nauczyciel.kartkowki",
  /**
   * Czy nauczyciel w panelu problemow widzi rozwiazania zadan.
   */
  NAUCZYCIEL_PROBLEMY_ROZWIAZANIA = "klient.nauczyciel.problemy.rozwiazania",
  NAUCZYCIEL_PROBLEMY_WYLACZONE = "klient.nauczyciel.problemy.wylaczone",
  NAUCZYCIEL_KATEGORYZACJA = "klient.nauczyciel.kategoryzacja",
  NAUCZYCIEL_KATEGORYZACJA_REKOMENDACJE = "klient.nauczyciel.kategoryzacja.rekomendacje",
  /**
   * Czy nauczyciel widzi rozwiazania w panelu zadawania pracy domowej. Domyslnie nie.
   */
  NAUCZYCIEL_ZADAWANIE_PRACY_DOMOWEJ_ROZWIAZANIA = "klient.nauczyciel.zadawanie-pracy-domowej.rozwiazania",
  NAUCZYCIEL_STATYSTYKI_ZADAN = "klient.nauczyciel.praca-domowa.statystyki-zadan",
  NAUCZYCIEL_PRACA_DOMOWA_LIMIT_CZASU = "klient.nauczyciel.praca-domowa.limit-czasu",
  NAUCZYCIEL_PRACA_DOMOWA_DYSPOZYCJE = "klient.nauczyciel.praca-domowa.dyspozycje",
  NAUCZYCIEL_PODSUMOWANIA_WIDOCZNE = "klient.nauczyciel.podsumowania-widoczne",
  NAUCZYCIEL_SPRAWDZIANY = "klient.nauczyciel.sprawdziany",
  NAUCZYCIEL_STATYSTYKI_KLAS = "klient.nauczyciel.statystyki-klas",
  NAUCZYCIEL_POSTEPY = "klient.nauczyciel.postepy",
  NAUCZYCIEL_POWTORKI_OBOWIAZKOWE = "klient.nauczyciel.powtorki-obowiazkowe",
  NAUCZYCIEL_ZADAWANIE_PRACY_DOMOWEJ_CWICZENIA = "klient.nauczyciel.zadawanie-pracy-domowej.cwiczenia",
  /**
   * Czy nauczyciel widzi panel nowosci. Domyslnie nie.
   */
  NAUCZYCIEL_NOWOSCI = "klient.nauczyciel.nowosci",
  CLICKSTREAM_WLACZONY = "klient.clickstream.wlaczony",
  CLICKSTREAM_INTERVAL = "klient.clickstream.interval",
  CLICKSTREAM_NAWIGACJA_MIEDZY_ZADANIAMI_WLACZONA = "klient.clickstream.nawigacja-miedzy-zadaniami.wlaczona",
  CLICKSTREAM_KLIKNIECIE_W_PRZYCISK_WLACZONE = "klient.clickstream.klikniecie-w-przycisk.wlaczone",
  CLICKSTREAM_WYSWIETLENIE_STRONY_WLACZONA = "klient.clickstream.wyswietlenie-strony.wlaczone",
  CLICKSTREAM_POMIAR_PERFORMANCE_API_WLACZONA = "klient.clickstream.pomiar-performance-api.wlaczony",
  CLICKSTREAM_WYJATEK_W_PRZEGLADARCE_WLACZONA = "klient.clickstream.wyjatek-w-przegladarce.wlaczony",
  CLICKSTREAM_ZALADOWANIE_APLIKACJI = "klient.clickstream.zaladowanie-aplikacji.wlaczony",
  KLIENT_EDYTOR_HTML_TEX = "klient.edytor-html.tex",
  KLIENT_UCZEN_ZGLOS_PROBLEM_Z_ZADANIEM_SCREENSHOT = "klient.uczen.zglos-problem-z-zadaniem.screenshot",
}
